import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { round } from 'lodash';
import NumericInput from 'react-numeric-input';
import Ttip from 'components/InlineTooltip';
import InfoIcon from 'material-ui/svg-icons/action/info';

import withViewportSize, { getViewportSize } from 'hoc/withViewportSize';

const NumericFormGroup = ({ input, placeholder, type, maxLength, disabled,
  readOnly, autoComplete, className, inputClassName, tooltip,
  id, autoFocus, meta: { touched, error } }) => {
  const isMobile = getViewportSize() === 'small';
  const numericProps = {
    className: cn(
      inputClassName,
      'numeric-input',
    ),
    min: 0,
    parse: round,
    value: input.value || 0,
    snap: true,
    step: 1,
    onFocus: e => e.target.select && e.target.select(),
    autoComplete: false,
    mobile: isMobile,
    style: {
      input: {
        width: isMobile ? '100%' : '50px',
      },
      btnUp: {
        background: 'transparent',
        boxShadow: 'none',
        border: 'none',
      },
      'btn:hover': {
        background: 'transparent',
      },
      btnDown: {
        background: 'transparent',
        boxShadow: 'none',
        border: 'none',
      },
    },
  };
  const inputElement = (
    <NumericInput
      {...input}
      {...numericProps}
      id={id}
      maxLength={maxLength}
      autoComplete={autoComplete}
      disabled={disabled}
      readOnly={readOnly}
      type={type}
      autoFocus={autoFocus}
      name={id}
    />
  );

  return (
    <div className={cn(
      'numeric-input-wrapper',
      { 'has-error': touched && error },
      { 'numeric-input-wrapper--is-mobile': isMobile },
      { 'numeric-input-wrapper--has-value': !!input.value && input.value > 0 },
      className)}
    >
      { inputElement }
      <label className="numeric-input__label" htmlFor={id}>
        { placeholder }
        { tooltip && <Ttip tooltipText={tooltip}>{' '}<InfoIcon style={{ width: '15px', height: '15px' }} /></Ttip> }
      </label>
    </div>
  );
};

NumericFormGroup.propTypes = {
  input: PropTypes.object.isRequired,
  // label: PropTypes.string,
  autoComplete: PropTypes.string,
  maxLength: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  id: PropTypes.string,
  meta: PropTypes.object,
  type: PropTypes.string,
  tooltip: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
    PropTypes.object,
  ]),
  inputClassName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  autoFocus: PropTypes.bool,
};

export default withViewportSize(NumericFormGroup);



// WEBPACK FOOTER //
// ./src/components/Forms/NumericFormGroup.js